var render, staticRenderFns
import script from "./LoadLabelsMixin.vue?vue&type=script&lang=js"
export * from "./LoadLabelsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47316c",
  null
  
)

export default component.exports